import { render, staticRenderFns } from "./AboutMenu.vue?vue&type=template&id=3be85dd3&scoped=true"
import script from "./AboutMenu.vue?vue&type=script&lang=js"
export * from "./AboutMenu.vue?vue&type=script&lang=js"
import style0 from "./AboutMenu.vue?vue&type=style&index=0&id=3be85dd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be85dd3",
  null
  
)

export default component.exports